// @ts-strict-ignore
import React from 'react';
import {
  Badge, Box, Icon, IconName,
} from '@usealloy/component-library';
import { capitalize } from '~/analytics/utils/helpers';
import type { BadgeStatusWithIcon, IncomingBankAccountStatus } from './types';

export const BankAccountStatusBadge = ({
  pendingStatus,
  status,
  iconOnly = false,
}: {
  pendingStatus?: IncomingBankAccountStatus;
  status: IncomingBankAccountStatus | null;
  iconOnly?: boolean;
}) => {
  const statusConfig: Record<IncomingBankAccountStatus | 'default', BadgeStatusWithIcon> = {
    active: { icon: IconName.Lock, status: 'eventSuccess' },
    frozen: { icon: IconName.Warning, status: 'eventWarning' },
    deactivated: { icon: IconName.Declined, status: 'eventRejected' },
    default: { icon: IconName.Question, status: 'unknown' },
  };

  const { icon, status: badgeStatus } = statusConfig[status?.toLowerCase() || 'default'];

  const text = capitalize(status || 'unknown');

  if (pendingStatus && pendingStatus?.toLowerCase() !== status?.toLowerCase()) {
    const pendingText = capitalize(pendingStatus || 'unknown');

    const {
      icon: pendingIcon,
      status: pendingBadgeStatus,
    } = statusConfig[pendingStatus?.toLowerCase() || 'default'];

    return (
      <Box justifyContent="flex-start">
        <Badge
          icon={icon}
          iconSize="small"
          status={badgeStatus}
        >
          {!iconOnly ? text : ''}
        </Badge>
        <Icon
          icon={IconName.ArrowRight}
          size="small"
          style={{
            marginTop: 'var(--cl-space-1)',
            marginLeft: 'var(--cl-space-2)',
            marginRight: 'var(--cl-space-2)',
          }}
        />
        <Badge
          icon={pendingIcon}
          iconSize="small"
          status={pendingBadgeStatus}
        >
          {!iconOnly ? pendingText : ''}
        </Badge>
      </Box>
    );
  }

  return (
    <Badge
      icon={icon}
      iconSize="small"
      status={badgeStatus}
    >
      {!iconOnly ? text : ''}
    </Badge>
  );
};
